'use client';
import { Button } from '@/components/ui/button';
import { useSocialSignIn } from '@/hooks/useSocialSignIn';
import Image from 'next/image';
import React, { FC } from 'react';

interface SocialAuthProps {
  isSignin?: boolean;
}

export const SocialAuth: FC<SocialAuthProps> = ({ isSignin }) => {
  const { handleSocialSignIn } = useSocialSignIn();

  return (
    <div className="space-y-2">
      <Button
        onClick={() => handleSocialSignIn('google')}
        className="uppercase w-full font-bold"
        variant="outline"
      >
        <Image
          className="size-4"
          src="/google-icon.svg"
          alt="Google"
          width={20}
          height={20}
        />
        {isSignin ? 'Login with Google' : 'Sign up with Google'}
      </Button>
      <Button
        onClick={() => handleSocialSignIn('linkedin')}
        className="uppercase w-full font-bold"
        variant="outline"
      >
        <Image
          className="size-4"
          src="/linkedin-icon.svg"
          alt="Google"
          width={20}
          height={20}
        />
        {isSignin ? 'Login with LinkedIn' : 'Sign up with LinkedIn'}
      </Button>
    </div>
  );
};
